<script lang="ts">
	import type { Contact } from '../scripts/classes/page';
	export let inContact: Contact;

</script>

<style lang="scss">

	.contact {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
		font-family: 'Borna-Medium';
		font-size: 14px;
		width: 100%;
		&__title {
			font-weight: bold;
			margin: 0 0 10px 0;
			min-height: 30px;
		}
		&__social {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: center;
			margin: 5px 0 0 0;
			&__linkedin {
                width: 30px;
                height: 30px;
				margin: 0 5px 0 0;
                cursor: pointer;
                background-image: url('../assets/images/linkedin.svg');
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                &:hover {
                    background-image: url('../assets/images/linkedin_hover.svg');
                }
			}
			&__email {
                width: 36px;
                height: 30px;
                cursor: pointer;
                background-image: url('../assets/images/email.svg');
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                &:hover {
                    background-image: url('../assets/images/email_hover.svg');
                }
			}
		}
	}

	@include large {
		.contact {
			font-size: 1.2vw;
		}
	}

	@include xlarge {
		.contact {
			font-size: 16px;
		}
	}

</style>

<div class="contact">
	<div class="dotline dotline__contact"></div>
	<div class="contact__title">{inContact.title}</div>
	<div class="contact__name">{inContact.subtitle}</div>
	<div class="contact__name">{inContact.name}</div>
	<div class="contact__function">{inContact.job}</div>
	<div class="contact__social">
		{#if (inContact.linkedin != "")}
		<a href="{inContact.linkedin}" target="_blank"><div class="contact__social__linkedin"></div></a>
		{/if}
		{#if (inContact.email != "")}
		<a href="mailto:{inContact.email}" target="_blank"><div class="contact__social__email"></div></a>
		{/if}
	</div>
</div>
